var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"alert",class:[_vm.typeClass, _vm.sizeClass]},[_vm._t("default"),_c('a',{staticClass:"link-close",on:{"click":_vm.remove}},[_c('span',{staticClass:"fa fa-close"})])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }